import type { AreaRoute } from "./areaRoute";
import { lazyPage } from "../../lib/lazyPage";

// Platform admin area (release 0.2.0 Step C): data sync, data health, communications, notifications, wall displays,
// feedback, adoption and ROI.
export const DataSyncPage = lazyPage(() => import("../admin/DataSyncPage"), "DataSyncPage");
export const DataHealthPage = lazyPage(() => import("../admin/DataHealthPage"), "DataHealthPage");
export const AdminNotificationsPage = lazyPage(() => import("../platform/AdminNotificationsPage"), "AdminNotificationsPage");
export const CommunicationsPage = lazyPage(() => import("../platform/CommunicationsPage"), "CommunicationsPage");
export const WallDisplaysPage = lazyPage(() => import("../platform/WallDisplaysPage"), "WallDisplaysPage");
export const FeedbackPage = lazyPage(() => import("../platform/FeedbackPage"), "FeedbackPage");
export const AdoptionPage = lazyPage(() => import("../platform/AdoptionPage"), "AdoptionPage");
export const RoiPage = lazyPage(() => import("../platform/RoiPage"), "RoiPage");

export const platformRoutes: AreaRoute[] = [];
